import Keycloak from 'keycloak-js';
import MCPMarketEnvironmentDetection, {
  MCP_MARKET_ENVIRONMENTS,
} from './shared/utils/market-environment-detection';

const marketEnvironmentData = MCPMarketEnvironmentDetection.getMarketEnvironment();
const KEYCLOAK_CONFIGS = {
  [MCP_MARKET_ENVIRONMENTS.LTA]: {
    url: process.env.KEYCLOAK_URL_LTA as string,
    realm: process.env.KEYCLOAK_REALM_LTA as string,
    clientId: process.env.KEYCLOAK_CLIENT_LTA as string,
  },
  [MCP_MARKET_ENVIRONMENTS.LJE]: {
    url: KEYCLOAK_URLS_LJE[marketEnvironmentData.countryCode] as string,
    realm: marketEnvironmentData.countryCode,
    clientId: process.env.KEYCLOAK_CLIENT_LJE as string,
  },
};

const currentKeyCloakConfig = KEYCLOAK_CONFIGS[marketEnvironmentData.market];

const keycloak = new Keycloak(currentKeyCloakConfig);

export default keycloak;
